:host {
  display: grid;
  block-size: 100%;
}

.search {
  display: grid;
  grid-template-rows: max-content 1fr;
  gap: var(--spacing-gap-xl);

  &__header {
    display: grid;
    grid-template-columns: 1fr;
  }

  &__results {
    position: relative;
  }
}
ch-tree-view-render::part(root-item item__header) {
  padding-inline-start: 0;
  font-weight: var(--font-style-semi-bold);
  font-size: var(--font-size-body-s);
  line-height: var(--line-height-relaxed);
  font-family: var(--font-family-body);
}
ch-tree-view-render::part(search-item item__header) {
  padding-inline-start: 0;
  font-weight: var(--font-style-regular);
  font-size: var(--font-size-body-s);
  line-height: var(--line-height-relaxed);
  font-family: var(--font-family-body);
  color: var(--color-text-neutral-neutral) !important;
}
.input--loading::part(start-img) {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
